export default __webpack_public_path__ + "static/media/Tanishka Gaur.e8d2c38e.JPG";